export default __webpack_public_path__ + "static/media/fbookicon.3a7c4a27.svg";